<template>
  <div style="background:#f5f5f5;">
    <member-header></member-header>
    <div class="order_details_title">
      <span>个人中心 > </span>
      <span>我的订单 > </span>
      <span>订单号：{{orderData.scode}} </span>
    </div>
    <div class="order_details">
      <div class="order_details_step clearfix_">
        <div class="fl step_state">
          <p class="state_">
            {{orderData.status==1?'待支付':''}}
            {{orderData.status==2?'待发货':''}}
            {{orderData.status==3?'待收货':''}}
            {{orderData.status==4?'待评价':''}}
            {{orderData.status==5?'已评价/待追评':''}}
            {{orderData.status==6?'已完成':''}}
            {{orderData.status==-1?'已取消':''}}
            {{orderData.status==-2?'已删除':''}}
            {{orderData.status==-3?'彻底删除':''}}
          </p>
          <p style="text-align:center;">
            <span v-show="orderData.status==1" @click="goToStayPay" class="btn_">立即支付</span>
            <span v-show="orderData.status==1" @click="updateOrderStatus('取消')" class="btn_">取消订单</span>
            <span v-show="orderData.status==-1" @click="updateOrderStatus('删除')" class="btn_">删除订单</span>
            <span v-show="orderData.status==-1||orderData.status==-2" @click="updateOrderStatus('彻底删除')" class="btn_">彻底删除</span>
            <span v-show="orderData.status==3" @click="updateOrderStatus('确认收货')" class="btn_">确认收货</span>
            <span v-show="orderData.status==4" @click="goToEvaluate('评价')" class="btn_">评价</span>
            <span v-show="orderData.status==5" @click="goToEvaluate('追加评价')" class="btn_">追加评价</span>
            <span v-show="orderData.isReturn==1" @click="goTOSeeReturnGoods" class="btn_">查看退货</span>
            <span v-show="orderData.returnStatusForOrder==1||orderData.returnStatusForOrder==2" @click="totalReturnGoods" class="btn_">{{orderData.returnStatusForOrder==1?'整单退款':'整单退货'}}</span>
          </p>
          <div v-show="orderData.status==1" class="orderDetails_failure_time">{{timeArr}}</div>
          <p class="clearfix_">
            <span class="printing_">打印订单</span>
            <i class=""></i>
            <span class="complaint_">投诉商家</span>
          </p>
        </div>
        <div class="fl step_">
          <ul style="margin-left:10px;" class="clearfix_">
            <li class="fl step_no">
              <div>
                <p>提交订单</p>
                <div class="clearfix_">
                  <i :class="{color:state_>0&&state_!=5&&state_!=6}" style="margin-left:82px;" class="fl">1</i>
                  <span :class="{background:state_>0&&state_!=5&&state_!=6}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>支付成功</p>
                <div class="clearfix_">
                  <span :class="{background:state_>1&&state_!=5&&state_!=6}" class="fl"></span>
                  <i :class="{color:state_>1&&state_!=5&&state_!=6}" class="fl">2</i>
                  <span :class="{background:state_>1&&state_!=5&&state_!=6}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>商家发货</p>
                <div class="clearfix_">
                  <span :class="{background:state_>2&&state_!=5&&state_!=6}" class="fl"></span>
                  <i :class="{color:state_>2&&state_!=5&&state_!=6}" class="fl">3</i>
                  <span :class="{background:state_>2&&state_!=5&&state_!=6}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>确认收货</p>
                <div class="clearfix_">
                  <span :class="{background:state_>3&&state_!=5&&state_!=6}" class="fl"></span>
                  <i :class="{color:state_>3&&state_!=5&&state_!=6}" class="fl">4</i>
                  <span :class="{background:state_>3&&state_!=5&&state_!=6}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>评价</p>
                <div class="clearfix_">
                  <span :class="{background:state_>4&&state_!=5&&state_!=6}" class="fl"></span>
                  <i :class="{color:state_>4&&state_!=5&&state_!=6}" class="fl">5</i>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-show="orderData.status>=3&&orderData.orderModel!=1" class="order_logistics_title">物流信息 <span @click="see"> 查看</span></div>
      <div v-for="(item,index) in logisticsList" :key="index" v-show="orderData.sendGoodsNum>0">
        <div v-show="logisticsBlock" class="order_logistics">
          <div class="order_logistics_package clearfix_">
            <p class="txt1 fl">包裹{{index+1}}</p>
            <p v-show="item.num" class="txt2 fl">共{{item.num}}件商品</p>
            <p class="txt3 fl">{{item.firm}} {{item.logisticsNo}}</p>
            <p v-show="item.checkStatus==1" class="txt3 fl"> 状态： 待分拣</p>
            <p v-show="item.checkStatus==2" class="txt3 fl"> 状态： 分拣中</p>
            <p v-show="item.checkStatus==3" class="txt3 fl"> 状态： 配送中</p>
            <p v-show="item.checkStatus==4" class="txt3 fl"> 状态： 已完成</p>
            <p v-show="item.checkStatus==5" class="txt3 fl"> 状态： 已取消</p>
            <p v-show="item.checkStatus==6" class="txt3 fl"> 状态： 已终止</p>
            <p class="txt4 fr">发货编号：{{item.scode}}</p>
          </div>
          <div class="order_logistics_imgs clearfix_">
            <img v-for="(val,idx) in item.items" :key="idx" class="fl" :src="val.pic?val.pic:timg" alt="">
          </div>
          <!-- <ul>
            <li class="clearfix_">
              <p class="fl txt1">2018-10-27 10:58:00</p>
              <p class="fl txt2">送货服务已完成，欢迎再次光临</p>
            </li>
            <li class="clearfix_">
              <p class="fl txt1">2018-10-27 10:58:00</p>
              <p class="fl txt2">送货服务已完成，欢迎再次光临</p>
            </li>
          </ul> -->
          <!-- <div class="order_logistics_more"><span>查看全部商品物流</span></div> -->
        </div>
      </div>
      <div class="order_information">
        <p class="order_title_">订单信息</p>
        <ul class="clearfix_">
          <li class="fl clearfix_"><b class="fl">订单编号：</b><span class="fl">{{orderData.scode}}</span></li>
          <li class="fl clearfix_"><b class="fl">下单时间：</b><span class="fl">{{orderData.dateCreated}}</span></li>
          <li class="fl clearfix_"><b class="fl">商户：</b><span class="fl">{{orderData.tenantName}}</span></li>
        </ul>
      </div>
      <div>
        <div class="order_goods_information">
          <p class="order_goods_title">商品信息</p>
          <div class="order_goods_explain clearfix_">
            <p class="fl goodsName">商品名称</p>
            <p class="fl price">单价</p>
            <p class="fl num">数量</p>
            <p class="fl subtotal">小计</p>
            <p class="fl integral">商品积分</p>
            <p class="fl mode">优惠方式</p>
            <p class="fl operation">商品操作</p>
          </div>
        </div>
        <ul class="order_goods_information_ul">
          <li v-for="(item,index) in orderData.goodsData" :key="index" class="clearfix_">
            <img class="fl" :src="item.pic?item.pic:timg" alt="">
            <p @click="toGoods(item.domain,item.goodsId,item.supplyChainTenantId)" class="goodsName fl">{{item.goodsName}}<br/>{{item.unitName}} {{item.property1}}</p>
            <p class="price fl">¥{{item.salesMoney}}</p>
            <p class="num fl">{{item.num}}</p>
            <p class="fl subtotal">{{item.totalPrice}}</p>
            <p class="fl integral">{{item.memberScore}}</p>
            <p class="fl mode">
               <span v-show="item.privilegePrice!='0.00'">优惠{{item.privilegePrice}}</span><br v-show="item.privilegePrice!='0.00'">
              <span v-show="item.score">{{item.score}}分</span><br v-show="item.score">
              <span v-show="item.giftNum">赠{{item.giftNum}}</span> 
            </p>
            <p class="operation fl clearfix_">
              <span class="fl" v-show="item.returnStatus==2" @click="replacementGoods(state_,item.id,item.returnNumber)">退货/退款</span>
              <span class="fl" v-show="item.returnStatus==1" @click="replacementGoods(state_,item.id,item.returnNumber)">退款</span>
              <span class="fl" v-show="item.returnStatus==3" @click="toWaitFor(item.id,item.returnNumber)">查看申请</span>
              <span class="fl" v-show="item.retailReturnItemNum==1" @click="seeDetails(item.id,item.returnNumber,item.isAllow,1,orderData.id,item.retailReturnItemId)">查看详情</span>
              <span class="fl" v-show="item.retailReturnItemNum>1" @click="seeDetails(item.id,item.returnNumber,item.isAllow,2,orderData.id,item.retailReturnItemId)">查看详情</span>
            </p>
          </li>
        </ul>
      </div>
      <div v-show="pmnGiftDataLength">
        <div class="order_goods_information">
          <p class="order_goods_title">赠品信息</p>
          <div class="order_goods_explain clearfix_">
            <p class="fl goodsName">商品名称</p>
            <p class="fl price">加价金额</p>
            <p class="fl num">数量</p>
          </div>
        </div>
        <ul class="order_goods_information_ul">
          <li v-for="(item,index) in orderData.pmnGiftData" :key="index" class="clearfix_">
            <img class="fl" :src="item.pic?item.pic:timg" alt="">
            <p @click="toGoods(item.domain,item.goodsId,item.supplyChainTenantId)" class="goodsName fl">{{item.goodsName}}<br/>{{item.goodsUnitName}} {{item.property1}}</p>
            <p class="price fl">¥{{item.addPrice}}</p>
            <p class="num fl">{{item.num}}</p>
          </li>
        </ul>
      </div>
      <div style="padding-bottom:20px;margin-bottom:20px;" v-show="promotionDataLength">
        <div class="order_goods_information">
          <p class="order_goods_title">促销信息</p>
          <div class="activity clearfix_">
            <p class="fl">活动明细</p>
            <p class="fl">明细内容</p>
            <p class="fl">活动名称</p>
            <p class="fl">类型</p>
          </div>
        </div>
        <div class="activityDetailed">
          <ul class="clearfix_">
            <li class="clearfix_" v-for="(item,index) in orderData.promotionData" :key="index">
              <p style="text-align:left;" :title="item.condition+item.method+item.pmnPrivilege" class="fl">{{item.condition}}{{item.method}}{{item.pmnPrivilege}}</p>
              <p class="fl"><span v-show="parseFloat(item.money)!=0">{{item.money}}</span><span v-show="item.giftNum">{{item.giftNum}}</span><span v-show="item.score">{{item.score}}</span></p>
              <p class="fl" :title="item.name">{{item.name}}</p>
              <p class="fl">{{item.type}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="order_goods_algorithm clearfix_">
        <ul class="fr">
          <li class="clearfix_">
            <p class="fl name_">商品总额</p>
            <p class="fr price_">{{orderData.receivable}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">品类优惠</p>
            <p class="fr price_">{{orderData.pmnGoodsPrivilege}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">订单优惠</p>
            <p class="fr price_">{{orderData.pmnOrderPrivilege}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">优惠券优惠</p>
            <p class="fr price_">{{orderData.pmnCouponPrivilege}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">加价金额</p>
            <p class="fr price_">{{orderData.pmnAddPricePrivilege}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">运费</p>
            <p class="fr price_">{{orderData.postageMoney}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">商品数量</p>
            <p class="fr price_">{{orderData.num}}</p>
          </li>
        </ul>
        <ul style="margin-right:50px;" class="fr">
          <li class="clearfix_">
            <p class="fl name_">商品积分</p>
            <p class="fr price_">{{orderData.memberScore}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">促销积分</p>
            <p class="fr price_">{{orderData.pmnScore}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">优惠券</p>
            <p class="fr price_">{{orderData.sendCouponNum}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">赠品</p>
            <p class="fr price_">{{orderData.promotionGiftNum}}</p>
          </li>
        </ul>
      </div>
      <div class="total_information">
        <div class="total_information_total">实付金额 ：<span>{{orderData.totalAmount}}</span></div>
        <div class="total_information_detailed clearfix_">
          <div class="fr">
            <div v-show="parseFloat(orderData.memberMoney)" class="fl">余额付款 <span>¥ {{orderData.memberMoney}}</span></div>
            <div v-show="parseFloat(orderData.cardMoney)" class="fl">储值卡付款 <span>¥ {{orderData.cardMoney}}</span></div>
            <div v-show="orderData.payType" class="fl"><span>{{orderData.payType}}</span>付款<span>¥ {{orderData.payTypeMoney}}</span></div>
          </div>
        </div>
        <div class="total_information_contacts clearfix_">
          <div class="fr">
            <div class="fl">收货地址：{{orderData.address}}</div>
            <div class="fl">收货人：{{orderData.recipient}}</div>
            <div class="fl">电话：{{orderData.mobilePhone}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import memberHeader from '@/components/member/member_header'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime,getTimeLeft } from '../../assets/js/public.js'
export default {
  components:{
		memberHeader
  },
  data(){
    return {
      orderData:{},
      timg:require('../../assets/img/timg.gif'),
      state_:0,
      logisticsList:[],
      logisticsBlock:false,
      pmnGiftDataLength:true,
      promotionDataLength:true,
      timeArr:'00:00:00',
      timer:null
    }
  },
  mounted:function(){
    var t_=this
    t_.getOrder()
  },
  methods:{
    goTOSeeReturnGoods:function(){
      var t_=this
      var href=this.$router.resolve({name:'viewReturns',query:{orderId:t_.orderData.id}})
      return window.open(href.href,'_blank')
    },
    toGoods:function(web,id,supplyChainTenantId){
      var t_=this
      var url='http://'+web+'/goodsdetails?goodsId='+id+'&supplyChainTenantId='+supplyChainTenantId+'&isSupplyChainGoods=2'
      window.open(url,'_blank')
    },
    seeDetails:function(id,num,isAllow,type,orderId,retailReturnItemId){
      var t_=this
      if(type==1){
        if(isAllow==2){
          t_.$router.push({path: '/replacementGoods',query: {id:id,num:num,step:4,isAllow:isAllow,orderId:orderId,retailReturnItemId:retailReturnItemId}})
        }else if(isAllow==4){
          t_.$router.push({path: '/replacementGoods',query: {id:id,num:num,step:3,isAllow:isAllow,orderId:orderId,retailReturnItemId:retailReturnItemId}})
        }
      }else{
        var href=this.$router.resolve({name:'returnGoodsList',query:{orderId:orderId}})
      	return window.open(href.href,'_blank')
      }
      
    },
    toWaitFor:function(id,num){
      var t_=this
      t_.$router.push({path: '/replacementGoods',query: {id:id,num:num,step:2,orderId:t_.orderData.id}})
    },
    goToStayPay:function(){
      this.$router.push({name: 'stayPay',query:{id:this.orderData.outTradeNo,orderId:this.orderData.id}})
    },
    replacementGoods:function(n,id,num,isAllow,totalReturn){
      var t_=this
      var step=1
      if(isAllow==3)step=3
      t_.$router.push({path: '/replacementGoods',query: {id:id,num:num,step:step,isAllow:isAllow,orderId:t_.orderData.id,totalReturn:totalReturn}})
    },
    totalReturnGoods:function(){
      var t_=this
      t_.$router.push({path: '/replacementGoods',query: {totalReturn:1,step:1,orderId:t_.orderData.id}})
    },
    goToEvaluate:function(name){
      var t_=this
      var isAppend
      if(name=='评价'){
        isAppend=''
      }
      if(name=='追加评价'){
        isAppend=1
      }
      t_.$router.push({
        name: 'evaluateOrder',
        query: {id: t_.$route.query.id,isAppend:isAppend}
      })
    },
    see:function(){
      var t_=this
      t_.logisticsBlock=!t_.logisticsBlock
    },
    updateOrderStatus:function(name){
      var t_=this
      var message=''
      if(name=='取消')message='确定要取消该订单吗？'
      if(name=='删除')message='确定要删除该订单吗？'
      if(name=='彻底删除')message='确定要彻底删除该订单吗？'
      if(name=='确认收货'){
        if(t_.orderData.sendStatus==2&&t_.orderData.stockStatus==2){
          message='部分商品未发货，是否确认收货？'
        }else if(t_.orderData.sendStatus==3){
          message='确定要收货吗？'
        }
      }
      console.log(name,message)
      t_.$confirm(message,'提示',{
        confirmButtonText:'确认',
        cancelButtonText:'取消',
        // distinguishCancelAndClose:true,
        type:'warning'
      }).then(()=>{
        var data0bj={
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          ids:t_.$route.query.id
        }
        if(name=='取消')data0bj.status=5
        if(name=='删除')data0bj.status=6
        if(name=='彻底删除')data0bj.status=7
        if(name=='确认收货')data0bj.status=4
        data0bj=Qs.stringify(data0bj)
        axios.post(`${ip}formWorkInterface/updateOrderStatus`,data0bj).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.$message({
              message:res.data.message,
              center:true,
              type:'success'
            })
            var n
            if(name=='取消')n=5
            if(name=='删除')n=6
            if(name=='彻底删除')n=0
            if(name=='确认收货')n=4
            t_.$router.push({
              name: 'order',
              query: {state: n}
            })
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
          }
        })
      }).catch(action=>{
        
      });
    },
    getLogisticsById:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.id
      })
      axios.post(`${ip}formWorkInterface/logisticsById`,data0bj).then(res=>{
        console.log(res)
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.logisticsList=res.data.data.Rows
        }
      })
    },
    prefixZero :function (num, n) {
      return(Array(n).join(0) + num).slice(-n);
    },
    getOrder:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.id
      })
      axios.post(`${ip}formWorkInterface/getOrderById`,data0bj).then(res=>{
        console.log(res,1)
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          // t_.getOrder()
          t_.orderData=res.data.data
          if(t_.orderData.pmnGiftData.length==0)t_.pmnGiftDataLength=false
          if(t_.orderData.promotionData.length==0)t_.promotionDataLength=false
          t_.state_=t_.orderData.status
          if(t_.orderData.sendGoodsNum>0)t_.getLogisticsById()
          if(t_.state_==3)t_.logisticsBlock=true
          t_.timer = setInterval(() => {
            t_.orderData.endTime = getTimeLeft(t_.orderData.l)
            t_.orderData.l = t_.orderData.l - 1000
            t_.timeArr=t_.orderData.endTime.split(':')
            t_.timeArr.forEach(function(item,index){
              t_.timeArr[index]=t_.prefixZero(item,2)
            },t_)
            t_.timeArr=t_.timeArr.join(':')
            if (t_.timeArr == "00:00:00") {
              clearInterval(t_.timer);
            }
          }, 1000)
        }
      })
    }
  }
}
</script>

<style scoped>
  .order_details_title{
    height: 40px;
    width: 1200px;
    margin: 0 auto;
    line-height: 40px;
    color:#333;
  }
  .order_details{
    width: 1198px;
    border: 1px solid #ddd;
    margin: 0 auto;
    background: #fff;
  }
  .order_details_step{
    height: 218px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
  }
  .step_state{
    width: 258px;
    height: 145px;
    border-right: 1px solid #ddd;
    padding-top: 73px;
    position: relative;
  }
  .step_state .state_{
    text-align: center;
    font-size:18px;
    color:#333;
    margin-bottom: 23px;
  }
  .step_state .btn_{
    width: 65px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin: 0 auto;
    cursor: pointer;
    display: inline-block;
  }
  .step_state .btn_:hover{
    color:#f60;
  }
  .step_state p:last-child{
    margin-top: 58px;
    text-align: center;
  }
  .step_state .printing_{
    color:#f60;
  }
  .step_state i{
    width: 2px;
    height: 12px;
    background: #cecece;
    margin:0 5px;
    display: inline-block;
  }
  .order_details_step .step_{
    width: 939px;
    height: 149px;
    padding-top: 69px;
  }
  .order_details_step .step_ li{
    width: 184px;
    height: 122px;
  }
  .order_details_step .step_ li span{
    width:82px;
    height: 6px;
    background: #ababab;
    margin-top: 7px;
  }
  .order_details_step .step_ li .background{
    background: #2abf5c; 
  }
  .order_details_step .step_ li i{
    width: 14px;
    height: 14px;
    border: 3px solid #ababab;
    border-radius: 50%;
    text-align: center;
    line-height: 14px;
    color:#ababab;
  }
  .order_details_step .step_ li .color{
    color:#2abf5c;
    border: 3px solid #2abf5c;
  }
  .order_details_step .step_ li p{
    margin: 13px 0;
    text-align: center;
  }
  .order_information{
    margin-left:40px;
    margin-bottom: 20px;
  }
  .order_title_{
    color:#333;
    margin-bottom: 18px;
  }
  .order_information li{
    width: 45%;
    margin-bottom: 13px;
    color:#999;
    margin-right: 5%;
  }
  .order_information li:nth-child(2n){
    margin-right: 0;
  }
  .order_information li span{
    width:430px;
    color:#333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height: 13px;
  }
  .order_goods_information{
    margin-left:40px;
    margin-bottom: 20px;
  }
  .order_goods_title{
    color:#333;
    margin-bottom: 10px;
  }
  .order_goods_explain{
    width: 1100px;
    height: 30px;
    background: #f5f5f5;
    color:#333;
  }
  .order_goods_information .activity p{
    width: 25%;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
  .activityDetailed{
    margin-left: 40px;
  }
  .activityDetailed p{
    width: 25%;
    text-align: center;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .order_goods_explain p{
    line-height: 30px;
  }
  .order_goods_explain .goodsName{
    width: 300px;
    text-align: center;
    cursor: pointer;
    /* margin: 0 106px 0 82px; */
  }
  .order_goods_explain .price,.order_goods_explain .num{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .operation{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .mode{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .integral{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .subtotal{
    width: 130px;
    text-align: center;
  }
  .order_goods_information_ul{
    width: 1100px;
    margin-left: 40px;
    border-bottom: 1px solid #eee;
    margin-bottom: 25px;
  }
  .order_goods_information_ul li{
    margin-bottom: 20px;
  }
  .order_goods_information_ul img{
    width: 62px;
    height: 62px;
    margin-right: 20px;
  }
  .order_goods_information_ul .goodsName{
    width: 218px;
    line-height: 20px;
    height: 62px;
    cursor: pointer;
  }
  .order_goods_information_ul .price,.order_goods_information_ul .num,.order_goods_information_ul .subtotal,.order_goods_information_ul .integral,.order_goods_information_ul .mode{
    width: 130px;
    height: 62px;
    text-align: center;
  }
  .order_goods_information_ul .mode{
    line-height: 18px;
  }
  .order_goods_information_ul .operation{
    width: 130px;
    height: 62px;
    text-align: center;
  }
  .order_goods_information_ul .operation span{
    line-height: 18px;
    cursor: pointer;
    width: 100%;
  }
  .order_goods_information_ul .operation span:hover{
    color:#f12002;
  }
  .order_goods_algorithm{
    width: 1100px;
    margin-left: 40px;
    margin-bottom: 40px;
  }
  .order_goods_algorithm ul{
    width: 230px;
  }
  .order_goods_algorithm li{
    margin-bottom: 10px;
  }
  .order_logistics{
    width: 1100px;
    margin-left:40px;
    min-height: 185px;
    border: 1px solid #ddd;
    margin-bottom: 30px;
  }
  .order_logistics_title{
    margin-left:40px;
    margin-bottom: 12px;
  }
  .order_logistics_title span{
    cursor: pointer;
  }
  .order_logistics_package{
    height: 35px;
    background: #f8f8f8;
    margin-bottom: 10px;
  }
  .order_logistics_package p{
    line-height: 35px;
  }
  .order_logistics_package .txt1{
    margin-left: 10px;
    margin-right: 15px;
    font-weight: 900;
    color:#333;
  }
  .order_logistics_package .txt2{
    color:#999;
    margin-right: 25px;
  }
  .order_logistics_package .txt3{
    margin-right: 10px;
  }
  .order_logistics_package .txt4{
    margin-right: 15px;
  }
  .order_logistics_imgs{
    margin-left: 40px;
  }
  .order_logistics_imgs img{
    width:62px;
    height: 62px;
    margin-right: 12px;
    margin-bottom: 5px;
  }
  .order_logistics ul{
    margin-left:14px;
  }
  .order_logistics li{
    height: 27px;
  }
  .order_logistics li p{
    line-height: 27px;
  }
  .order_logistics li .txt1{
    width: 138px;
    border-right:1px solid #ddd;
    margin-right: 20px;
  }
  .order_logistics_more{
    color:#28e;
    text-align: center;
    height: 22px;
    line-height: 22px;
    background: #f8f8f8;
  }
  .order_logistics_more span{
    cursor: pointer;
  }
  .orderDetails_failure_time{
    width: 100%;
    color:#333;
    text-align: center;
    position: absolute;
    left: 0;
    height: 12px;
    bottom: 45px;
  }
  .total_information{
    width: 1198px;
    background: #F2F2F2;
    padding-bottom: 15px;
  }
  .total_information_total{
    text-align: right;
    padding: 15px;
  }
  .total_information_total span{
    font-size: 22px;
    color: #ee0000;
  }
  .total_information_detailed{
    padding-right: 15px;
    margin-bottom: 17px;
  }
  .total_information_contacts{
    padding-right: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/components/member/order_details.vue